import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';

const CheckBox = ({
  isActive,
  size = 30,
  onPress,
  iconStyle,
  halfSelect,
  disabled,
  inActiveOverrideStyle
}) => {
  const dynamicStyles = {
    checkboxContainer: {
      borderWidth: 2,
      borderRadius: 3,
      marginRight: 10,
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      borderColor: Theme.PRIMARY,
    },
    activeCheckbox: {
      backgroundColor: Theme.PRIMARY,
    },
    halfSelectCheckbox: {
      backgroundColor: Theme.WHITE,
    },
    inactiveCheckbox: {
      backgroundColor: Theme.WHITE,
    },
    disabled: {
      backgroundColor: Theme.GREY_MEDIUM,
      borderColor: Theme.GREY_MEDIUM,
    },
  };

  return (
    <TouchableOpacity
      disabled={disabled}
      style={[
        dynamicStyles.checkboxContainer, {
          width: size,
          height: size,
        },
        isActive && halfSelect ? dynamicStyles.halfSelectCheckbox : isActive ? dynamicStyles.activeCheckbox : { ...dynamicStyles.inactiveCheckbox, ...inActiveOverrideStyle },
        disabled && dynamicStyles.disabled,
      ]}
      onPress={onPress}>
      {isActive &&
        <Icon
          size={size - 10}
          style={iconStyle}
          name={halfSelect ? "md-square" : "md-checkmark"}
          color={halfSelect ? Theme.PRIMARY : Theme.WHITE}
        />
      }
    </TouchableOpacity>
  );
};

export default CheckBox;
